import http from '@/httpCommon/axiosClient';
import { removeEmptyObject } from '@/util/removeEmptyObject';

class Profile {
    get = async () => {
        const res: any = await http.get('system-account/get/me');

        return res?.data;
    };
    getImage = async () => {
        const res: any = await http.get('system-account/get/me/image');

        return res?.data;
    };
    edit = async (body: any) => {
        body = removeEmptyObject(body);
        const res: any = await http.patch('system-account/get/me', { ...body });

        return res?.data;
    };
    editPassword = async (body: any) => {
        body = removeEmptyObject(body);
        const res: any = await http.patch('system-account/edit-password/me', { ...body });

        return res?.data;
    };
}
export default new Profile();
